var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.flag)?_c('router-view',{staticClass:"main-content-out clearfix",attrs:{"Platform":_vm.Platform,"CurrentIndex":_vm.Pager.CurrentIndex,"Pager":_vm.Pager}}):_vm._e(),_c('loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }